import { render, staticRenderFns } from "./recomlayadv.vue?vue&type=template&id=daa66b02&scoped=true&"
import script from "./recomlayadv.vue?vue&type=script&lang=js&"
export * from "./recomlayadv.vue?vue&type=script&lang=js&"
import style0 from "./recomlayadv.vue?vue&type=style&index=0&id=daa66b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa66b02",
  null
  
)

export default component.exports